import { useEffect, useState } from "react";
import { Career } from "../Types/Types";

const useCareerDetail = (id: string | undefined) => {
  const [career, setCareer] = useState<Career | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  const url = `${apiUrl}/api/adminCareer`;

  useEffect(() => {
    if (!id) return;

    const fetchCareerDetail = async () => {
      setLoading(true);
      setError(null);

      try {
        // Update the URL to include the `id` parameter
        const response = await fetch(`${url}/${id}`);
        
        if (!response.ok) throw new Error("Career not found");

        const data = await response.json();

        setCareer(data);
      } catch (err: any) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchCareerDetail();
  }, [id]);

  return { career, loading, error };
};

export default useCareerDetail;
